//#region src/redux/transient/thunk-types.ts
var thunkTypes = { UPDATE_TRANSIENT: `viewport/updateTransient` };
//#endregion
export { thunkTypes };

//# sourceMappingURL=thunk-types.js.map